import React, { useState } from 'react';
import { Container, Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import SingleCatalogDashboards from './singleCatalogGraph';
import MultiCatalogDashboards from './multiCatalogGraph';

const ProductsDashboard = () => {
  /** @typedef {'unico-catalogo' | 'multi-catalogos'} ProductsDashboard */
  /** @type {[ProductsDashboard, React.Dispatch<React.SetStateAction<ProductsDashboard>>]} */
  const [activeTab, setActiveTab] = useState('unico-catalogo');

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Container className="mt-6" fluid>
      <Nav tabs>
        <NavItem>
          <button
            className={classnames('nav-link', {
              active: activeTab === 'unico-catalogo'
            })}
            onClick={() => {
              toggleTab('unico-catalogo');
            }}
          >
            Catálogo Único
          </button>
        </NavItem>
        <NavItem>
          <button
            className={classnames('nav-link', {
              active: activeTab === 'multi-catalogos'
            })}
            onClick={() => {
              toggleTab('multi-catalogos');
            }}
          >
            Multi Catálogos
          </button>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="unico-catalogo">
          <SingleCatalogDashboards />
        </TabPane>
        <TabPane tabId="multi-catalogos">
          <MultiCatalogDashboards />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default ProductsDashboard;
